import React from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
  return (
    <div className="home-container" style={{
      padding: '40px 20px',
      maxWidth: '1200px',
      margin: '0 auto',
      minHeight: 'calc(100vh - 120px)'
    }}>
      <div style={{ marginBottom: '40px', textAlign: 'center' }}>
        <h1 style={{ color: '#2e7d32', marginBottom: '10px' }}>Bienvenido a Blossom</h1>
        <p style={{ fontSize: '1.1em', color: '#555' }}>¿Qué te gustaría hacer hoy?</p>
      </div>
      
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '30px',
        marginTop: '20px'
      }}>
        <Link to="/dashboard" style={{ textDecoration: 'none', flex: '1', minWidth: '300px', maxWidth: '400px' }}>
          <div style={{
            ...cardStyle,
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)',
            color: 'white',
            transition: 'transform 0.3s, box-shadow 0.3s'
          }}>
            <div style={{ fontSize: '3em', marginBottom: '15px' }}>❤️</div>
            <h2 style={{ margin: '0 0 10px 0', fontSize: '1.5em' }}>Programa Cardiometabólico</h2>
            <p style={{ margin: 0, opacity: 0.9, textAlign: 'center' }}>Acceso al programa Cardiometabólico</p>
          </div>
        </Link>
        
        <Link to="/turnos-asignados" style={{ textDecoration: 'none', flex: '1', minWidth: '300px', maxWidth: '400px' }}>
          <div style={{
            ...cardStyle,
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
            color: 'white',
            transition: 'transform 0.3s, box-shadow 0.3s'
          }}>
            <div style={{ fontSize: '3em', marginBottom: '15px' }}>📅</div>
            <h2 style={{ margin: '0 0 10px 0', fontSize: '1.5em' }}>Turnos</h2>
            <p style={{ margin: 0, opacity: 0.9, textAlign: 'center' }}>Gestiona tus turnos programados</p>
          </div>
        </Link>
      </div>
    </div>
  );
};

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: '12px',
  padding: '25px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  transition: 'transform 0.3s, box-shadow 0.3s',
  cursor: 'pointer',
  color: '#333',
  boxSizing: 'border-box',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 8px 20px rgba(0,0,0,0.15)'
  }
};

export default HomePage;
